import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
@Component({
  template: '',
})
export class PaymentTileBaseComponent {
  @Input() platformEnum: PlatformEnum;
  @Input() isTouch: boolean;
  @Input() title: string;
  @Input() textBody?: string;
  @Input() textButton?: string;
  @Input() iconButton?: string;
  @Input() badgeText?: string;
  @Input() badgeColor?: string;

  @Output() actionClickEmitter = new EventEmitter();

  constructor() {}

  getDataCyAttr(attr: string) {
    if (attr) {
      return attr.replace(/ /g, '-').toLowerCase();
    }
  }

  actionClick() {
    this.actionClickEmitter.emit();
  }
}
